// extracted by mini-css-extract-plugin
module.exports = {"inheritColorLink":"BreadcrumbElement_inheritColorLink__HI14M","root":"BreadcrumbElement_root__PrE9b","link":"BreadcrumbElement_link__iPZPi"};